

















































import CommonBase from "../CommonBase";
import {Component, Emit, Prop} from "vue-property-decorator";
import {PurchaseItem, PurchaseOrder} from "../../modules/models";
import EllipsisScroller from "../EllipsisScroller.vue";
import {numFormNOK} from "@/modules/utils";

@Component({
    components: {
        "at-ellipsis-scroller": EllipsisScroller,
    }
})
export default class OrderItemsList extends CommonBase{
    @Prop()
    order!: PurchaseOrder;

    nokFormatted(num: number) {
        return numFormNOK(num);
    }

    @Emit("sub-item-amount")
    subItemAmount(it: PurchaseItem) {}

    @Emit("add-item-amount")
    addItemAmount(it: PurchaseItem) {}

}
